export const parseSearchParams = (search: string): Record<string, string> => {
  if (typeof search !== 'string' || !search) return {};

  try {
    return Object.fromEntries(new URLSearchParams(search));
  } catch (error) {
    console.error('Error parsing search params: ', error);
    return {};
  }
};
